// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"Error404_errorContainer__1fv-2","error":"Error404_error__1yprr"};